export class role{
    _id:any;
    roleName:any
    componentId:any;
    read:boolean=false;
    write:boolean=false;
}